// v2/utils/authStore.js
// Oturum deposu — eski projeyle AYNI localStorage anahtarlarini kullanir.
// user: {kod, status, ad_soyad, token}  |  token: string  |  rememberMe: {email, password, timestamp}

const USER_KEY = 'user';
const TOKEN_KEY = 'token';
const REMEMBER_KEY = 'rememberMe';
// useCari onbellegi — cikista temizlenir ki baska cari eski unvani gormesin
const CARI_KEY = 'v2_cari_bilgi';

export const LOGIN_YOLU = '/login';

const dinleyiciler = new Set();

function guvenliJson(raw) {
  try {
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function diskteOku() {
  if (typeof window === 'undefined') {
    return { token: null, user: null, girisli: false, admin: false };
  }
  const token = window.localStorage.getItem(TOKEN_KEY) || null;
  const user = guvenliJson(window.localStorage.getItem(USER_KEY));
  return {
    token,
    user,
    girisli: Boolean(token && user),
    admin: Boolean(user && user.status === 'admin'),
  };
}

// useSyncExternalStore kararli referans istedigi icin durumu onbellekte tutuyoruz.
let anlikDurum = diskteOku();

function yayinla() {
  anlikDurum = diskteOku();
  dinleyiciler.forEach((fn) => {
    try {
      fn();
    } catch (e) {
      /* dinleyici hatasi digerlerini engellemesin */
    }
  });
}

export function oturumBilgisi() {
  return anlikDurum;
}

export function abone(fn) {
  dinleyiciler.add(fn);
  return () => dinleyiciler.delete(fn);
}

export function oturumKaydet(user, { rememberMe, email, password } = {}) {
  if (!user || !user.token) return false;
  window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.localStorage.setItem(TOKEN_KEY, user.token);
  if (rememberMe) {
    window.localStorage.setItem(
      REMEMBER_KEY,
      JSON.stringify({ email, password, timestamp: new Date().getTime() })
    );
  } else {
    window.localStorage.removeItem(REMEMBER_KEY);
  }
  yayinla();
  return true;
}

export function hatirlananBilgi() {
  return guvenliJson(window.localStorage.getItem(REMEMBER_KEY));
}

// Oturumu temizler. yonlendir=true ise login sayfasina atar.
export function oturumuSonlandir({ yonlendir = true } = {}) {
  window.localStorage.removeItem(USER_KEY);
  window.localStorage.removeItem(TOKEN_KEY);
  try { window.sessionStorage.removeItem(CARI_KEY); } catch (e) { /* yok say */ }
  yayinla();
  if (yonlendir && typeof window !== 'undefined') {
    const suAn = window.location.pathname;
    if (suAn !== LOGIN_YOLU) {
      window.location.replace(LOGIN_YOLU);
    }
  }
}

// Baska sekmede cikis yapilirsa bu sekme de haberdar olsun.
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === TOKEN_KEY || e.key === USER_KEY) yayinla();
  });
}
